import { useSelector } from 'react-redux';
import { promotionKeys } from 'self-service-api/constants/Promotions';
import { allEligibleDiscountsSelector } from '../selectors/PromotionSelectors';
export default function () {
  const eligibleDiscounts = useSelector(allEligibleDiscountsSelector);
  const eligibleForHsfxDiscount = [promotionKeys.HSFS_SEED_V2, promotionKeys.HSFS_SEED_V3, promotionKeys.HSFS_SERIES_A_V2, promotionKeys.STRATEGIC_PARTNERSHIP, promotionKeys.HSFX_BOOTSTRAP, promotionKeys.HSFX_ENTREPRENEUR_V2].reduce((acc, hsfxDiscount) => acc || eligibleDiscounts.includes(hsfxDiscount), false);
  return eligibleForHsfxDiscount;
}